import React, { useState } from 'react';
import styles from '../styles/AboutUs.module.css';
import Member from './components/Member';

function AboutUs() {

    const [selectedMember, setSelectedMember] = useState(null); // Selected member

    const handleMemberClick = (member) => {
        setSelectedMember(member); // Select a member
    };

    const closePopup = () => {
        setSelectedMember(null); // Close the popup
    };

    return (
        <div className={styles.container}>
            <div className={styles.wrap}>
                {/* Company Overview Section */}
                <div id="company-overview" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Company Overview</h2>
                    <div className={styles.card}>
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <ul className={styles.infoList}>
                            <li><strong>Company Name:</strong><span className={styles.infoValue}>Parnas Inc.</span></li>
                            <li><strong>CEO:</strong><span className={styles.infoValue}>Takahiro Yamashita</span></li>
                            <li><strong>Business:</strong><span className={styles.infoValue}>CG Video Production</span></li>
                            <li><strong>Founded:</strong><span className={styles.infoValue}>March 2022</span></li>
                            <li><strong>Address:</strong><span className={styles.infoValue}>Keio Shinagawa Building 2F, Room 10, 2-17-1 Konan, Minato-ku, Tokyo</span></li>
                        </ul>
                    </div>
                </div>

                {/* CEO Message Section */}
                <div id="ceo-greeting" className={styles.section}>
                    <h2 className={styles.sectionTitle}>Message from the CEO</h2>
                    <div className={styles.ceoCard}>
                        <div className={styles.cornerTL}></div>
                        <div className={styles.cornerTR}></div>
                        <div className={styles.cornerBL}></div>
                        <div className={styles.cornerBR}></div>
                        <div className={styles.ceoContent}>
                            <img src="/images/member/yamashita.png" alt="CEO Takahiro Yamashita" className={styles.ceoImage} />
                            <div className={styles.ceoText}>
                                <div className={styles.ceoGreeting}>MISSION: ANIMATING ASSETS</div>
                                <p>
                                    We provide advanced services specializing in rigging.<br /><br />
                                    To create opportunities for creators across Japan in the highly specialized and challenging field of rigging, we operate fully remotely.<br /><br />
                                    This is how Parnas was born. Our team works together to refine our skills and bring inspiration to people around the world who eagerly await Japanese CG content.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Member Section */}
                <div id="member-intro" className={styles.section}>
                    <Member />
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
